import { Component, OnInit } from '@angular/core';

@Component({
    // tslint:disable-next-line: component-selector
    selector: 'app-load-indicator',
    templateUrl: './load-indicator.component.html',
    styleUrls: ['./load-indicator.component.css']
})
export class LoadIndicatorComponent implements OnInit {

    constructor() { }

    public ngOnInit(): void {
    }

}
